import { Box, Divider, Typography } from '@mui/material';
import { Button } from '@portals/core/src/components/Button/Button';
import { Bookmark } from '@portals/icons';
import React, { useContext } from 'react';

import { CatalogsContext } from '../../../context';
import { useEstateListHeadingFormatter } from '../../../hooks';
import { styles } from './Headline.styles';
import type { HeadlineProps } from './Headline.types';

export const Headline: React.FC<HeadlineProps> = ({
  searchParams,
  totalItems,
  onClickSaveSearch,
  saveSearchButtonLabel,
  isSaveSearchButtonDisabled,
  buttonContent,
}) => {
  const { estateSubTypes: catalogsEstateSubTypes } = useContext(CatalogsContext);
  const headingFormatter = useEstateListHeadingFormatter();

  return (
    <Box className="estate-list-headline-container" sx={styles.container}>
      <Box sx={styles.saveSearchWrapper} className="estate-list-button-container">
        {!isSaveSearchButtonDisabled && (
          <Button
            color="inherit"
            size="small"
            endIcon={<Bookmark />}
            sx={styles.saveSearchButton}
            onClick={onClickSaveSearch}
          >
            {saveSearchButtonLabel}
          </Button>
        )}
      </Box>

      <Box sx={styles.contentWrapper}>
        <Box className="estate-list-headline" sx={styles.headingWrapper}>
          <Typography variant="h2" sx={styles.headingText}>
            {headingFormatter(searchParams, totalItems, catalogsEstateSubTypes ?? null)}
          </Typography>
        </Box>
        {buttonContent}
      </Box>

      <Divider sx={styles.divider} />
    </Box>
  );
};

Headline.displayName = 'Headline';
